import { BoundaryType } from "./BoundaryType";
import { AreaTypeKey } from "./globalTypes";

export const BoundaryTypeKey = {
  AnnotationBoundary: { key: AreaTypeKey.ANNOTATION_BOUNDARY, name: "Annotation boundary" } as BoundaryType,
  PermitBoundary: { key: AreaTypeKey.PERMIT_BOUNDARY, name: "Permit boundary" } as BoundaryType,
} as const;

export const mapBoundaryTypeKeyToBoundaryType = (typeKey: AreaTypeKey) => {
  switch (typeKey) {
    case AreaTypeKey.PERMIT_BOUNDARY:
      return BoundaryTypeKey.PermitBoundary;
    case AreaTypeKey.ANNOTATION_BOUNDARY:
      return BoundaryTypeKey.AnnotationBoundary;
  }
};

export const mapBoundaryTypeNameToBoundaryType = (typeName: string) => {
  switch (typeName) {
    case BoundaryTypeKey.PermitBoundary.name:
      return BoundaryTypeKey.PermitBoundary;
    case BoundaryTypeKey.AnnotationBoundary.name:
      return BoundaryTypeKey.AnnotationBoundary;
  }
};
